import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-6eb42399"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "app-logo" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "img-regular"
    })
  ])
], -1))
const _hoisted_3 = { class: "actions-block" }
const _hoisted_4 = { class: "lang-picker" }
const _hoisted_5 = { class: "notification-bell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Dropdown, {
          class: "form-control",
          modelValue: _ctx.selectedLang,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedLang) = $event)),
          options: [_ctx.en, _ctx.de],
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadLocaleMessages(_ctx.selectedLang)))
        }, null, 8, ["modelValue", "options"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_fa, { icon: "fa-regular fa-bell" })
      ])
    ])
  ]))
}